<!-- 线下班 -->
<template>
  <section>
    <h2 class="cf-title cf" style="margin-top: 10px;margin-bottom: 10px">
      <label>{{module.title}}</label>
    </h2>      

    <div class="cf-main">
        <div class="live-course" v-for="(item, index) in module.contentpageofflinecourse_datas">
          <a :href="item.web_url" target="_blank">
            <el-card :body-style="{ padding: '5px' }">
              <div class="box"> 
                <img :src="item.web_imageurl" class="image">
                <div class="box_content">
                    <button>立即报名</button>
                     <!-- <a v-else :href="item.skip_web_content" target="_blank"></a>-->
                </div>
              </div>

              <div class="class_card_info">
                  <p class="cf ctitle"> 
                      <span class="tag">
                       报名人数  <b>{{againstPercent(item.sign_num)}}</b>
                      </span>
                  </p>

                  <h5 :title="item.title" class="title">
                    {{item.title}}
                  </h5>


                  <div class="oneline">
                      <p class="times">
                        <i class="el-icon-time"></i>
                        开班日期：<b>{{item.lesson_time}}</b> 
                      </p>
                      <p class="people">
                        <i class="el-icon-service"></i>
                        开课地点：<b>{{item.site}}</b>
                      </p>
                  </div>
              </div>
            </el-card>
          </a>
      </div>
    </div>

    
   </section>
</template>
<script>
  export default {
    name: "class-section-offline",
    props: ['module'],
    methods: {
      againstPercent: function(value) {
        var arr = value.split("/")
        return (parseInt(arr[0]) / parseInt(arr[1])) * 100 + '%'
      }
    }
  }

</script>

<style scoped>
 @import "../../common/style/classsection.css";
.live-course .image{
      width: 85%;
    -webkit-transition: 1s;
}
</style>


// WEBPACK FOOTER //
// src/components/Content/ClassSectionOffline.vue